import createSvgIcon from '../Utils/CreateSvgIcon';

export const Automatic = createSvgIcon(
  <path d="M10.9766 4.92188L7.97656 4.92188V2.92188H15.9766L15.9766 4.92188L12.9766 4.92188L12.9766 19.0781H15.9766L15.9766 21.0781H7.97656V19.0781H10.9766L10.9766 4.92188Z" />,
  'Automatic',
);
